import React from "react";
import { Link } from "react-router-dom";
class HiFiGear extends React.Component {
  render() {
    return (
      <li
        className="dropdown"
        onMouseEnter={() => this.props.open("HiFi")}
        onMouseLeave={this.props.close}
      >
        <a href="#" data-toggle="dropdown">
          HiFi<b className="caret"></b>
        </a>
        <ul
          className="nav-kits dropdown-menu"
          style={{
            visibility: this.props.opened == "HiFi" ? "visible" : "hidden",
          }}
        >
          <div className="pull-left multi-border">
            <h5>HiFi Tube Amp Kits</h5>
            {this.props.hifikits.map((itemMap, key) => (
              <li onClick={this.props.close} key={key}>
                <Link to={itemMap.path}>{itemMap.name}</Link>
              </li>
            ))}
          </div>

          <div className="pull-left size-control">
            <h5>HiFi Tube Amps</h5>
            {this.props.hifiamps.map((itemMap, key) => (
              <li onClick={this.props.close} key={key}>
                <Link to={itemMap.path}>{itemMap.name}</Link>
              </li>
            ))}
            <br />
            <h5>HiFi Gear</h5>
            {this.props.hifigear.map((itemMap, key) => (
              <li onClick={this.props.close} key={key}>
                <Link to={itemMap.path}>{itemMap.name}</Link>
              </li>
            ))}
          </div>
        </ul>
      </li>
    );
  }
}

export default HiFiGear;
